<template>
  <div :class="$style.card" @click="openCard">
    <div :class="$style.wrapper">
      <div v-if="object.super_additions" :class="$style.superAddition">
        <img src="@/assets/img/fire.svg" alt="" /> {{ object.super_additions }}
      </div>
      <div :class="[$style.photo, { [$style.withSuperAddition]: object.super_additions }]">
        <div :class="$style.additions">
          <p v-if="object.additions_one" :class="$style.addition">{{ object.additions_one }}</p>
          <p v-if="object.additions_two" :class="$style.addition">{{ object.additions_two }}</p>
          <p v-if="object.additions_three" :class="$style.addition">{{ object.additions_three }}</p>
          <p v-if="object.additions_four" :class="$style.addition">{{ object.additions_four }}</p>
        </div>
        <img v-if="this.$store.state.loadingCard" src="../assets/img/logo.svg" alt="" />
        <img
          v-else
          :src="
            object.photo_urls.length > 0 ? object.photo_urls[0] : '../assets/img/placeholder.png'
          "
          alt=""
        />
      </div>
      <div v-if="object.address" :class="$style.address">
        <img src="@/assets/img/address-black-color.svg" alt="" />
        <p>{{ object.address }}</p>
      </div>
      <div :class="$style.title">
        <p :class="$style.tag">Tag: {{ object.id }}</p>
        <p :class="$style.name">{{ object.header }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openCard() {
      this.$emit('openCard', this.object);
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}

.card {
  background-color: $white;
  border-radius: 16px;
  transition: all 0.5s ease;
}

.wrapper {
  width: 100%;
  border: none;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.2s ease;
  opacity: 100%;
  animation-name: show;
  animation-duration: 1s;
}

.superAddition {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 6px 0;
  font-size: 8px;
  background-color: $primary;
  img {
    width: 6px;
    margin-right: 4px;
    margin-bottom: 2px;
  }
}

.photo {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 175px;
  &.withSuperAddition {
    height: 120px;
  }
  .additions {
    position: absolute;
    top: 6px;
    left: 10px;
    display: flex;
    flex-wrap: wrap;
    .addition {
      background-color: $bg-dark;
      font-size: 8px;
      border-radius: 4px;
      padding: 3px;
      color: $white;
      text-wrap: nowrap;
      margin-top: 4px;
      margin-right: 4px;
    }
  }
  img {
    margin: 0;
    width: 100%;
    object-fit: cover;
    height: 100%;
  }
}

.address {
  display: flex;
  align-items: center;
  background-color: $primary;
  padding: 6px 16px;
  font-size: 8px;
  img {
    margin: 0 4px 0 0;
  }
}

.title {
  padding: 16px;
}

.tag {
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 1px;
  color: $black;
  margin-bottom: 5px;
}

.name {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  color: $black;
}
</style>
